// src/components/atomic-crm/providers/commons/getCompanyAvatar.ts
import type { Company } from "../../types";

export async function getCompanyAvatar(record: Partial<Company>): Promise<{
  src: string;
  title: string;
} | null> {
  // 1. Real logo URL wins
  if (record.logo_url) {
    return {
      src: record.logo_url,
      title: record.name ? `${record.name} logo` : "Company logo",
    };
  }

  // 2. Uploaded file or legacy stored logo
  if (record.logo?.src) {
    return {
      src: record.logo.src,
      title: record.logo.title ?? "Company logo",
    };
  }

  // 3. Derive a favicon from the website — Google's service is more reliable
  //    than favicon.show (which returns a placeholder image on failure).
  if (record.website) {
    try {
      const url = new URL(
        record.website.startsWith("http")
          ? record.website
          : `https://${record.website}`,
      );
      const host = url.hostname.replace(/^www\./, "");
      return {
        src: `https://www.google.com/s2/favicons?domain=${host}&sz=128`,
        title: "Company favicon",
      };
    } catch {
      // Invalid URL — fall through
    }
  }

  // 4. No icon available — caller renders initials
  return null;
}
